/* tslint:disable */
export enum Language {Czech = "CZECH",English = "ENGLISH"}
